import { Stack } from "@mui/system";
import WidgetTitle from "../widgets/WidgetTitle";
import { Box, Paper } from "@mui/material";

function AuthHeader(props) {
  return (
    <Box sx={{position: 'relative'}}>
      <Stack className="co-background-light" style={{ padding: '15px', width: 'auto', height: '80px' }} direction="row" justifyContent="space-between">

      </Stack>
      <img style={{position: 'absolute', top: '10px', left: '10px'}} src="/logo-new-glow.png" height="80" />
    </Box>
  );
}

export default AuthHeader;